import { Button, Input, useToast } from "@bandit-network/react-ui-kit";
import React, { useCallback, useState } from "react";
import { Task } from "../../../types";
import { useQuestContext } from "../../../context/QuestContext";
import { useWallet } from "@solana/wallet-adapter-react";
import { useAccount } from "wagmi";
import { useConnect } from "@bandit-network/react-wallet-kit";
import { CheckCircledIcon, ReloadIcon } from "@radix-ui/react-icons";
import { replaceHyperlinks } from "../../../utils/hyperlink";

export interface VerifyProps {
  data: Task;
}

const Verify: React.FC<VerifyProps> = ({ data }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [email, setEmail] = useState("");
  const { isConnectedEVM, isConnectedSOL, signature } = useConnect();
  const { publicKey: solanaAddress } = useWallet();
  const { address: evmAddress } = useAccount();

  const address = isConnectedSOL ? solanaAddress?.toBase58() : evmAddress;

  const { questSDK, questId, tasksCompleted } = useQuestContext();
  const { toast } = useToast();

  const isTaskComplete = tasksCompleted.includes(data?.id);

  const onSubmit = useCallback(async () => {
    if (!email) {
      toast({
        variant: "destructive",
        title: "Email is required.",
        description: "Enter your email.",
      });
    } else {
      try {
        setIsLoading(true);
        const response = await questSDK.sendEmailVerification(
          questId,
          data,
          address,
          email,
          signature.data,
        );
        toast({
          title: "Email sent",
          description: "Check your email.",
        });
        setEmailSent(true);
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    }
  }, [questSDK, address, email]);

  const enterPressed = (event: any) => {
    var code = event.keyCode || event.which;
    if (code === 13 && email?.length > 0) {
      //13 is the enter keycode
      onSubmit();
    }
  };

  return (
    <div className="bad-quest__task">
      <p className="bad-quest__task--description">
        {replaceHyperlinks(data.description)}
      </p>
      <Input
        placeholder="Enter Your Email"
        className="bad-quest__task--input"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        onKeyDown={enterPressed}
        disabled={emailSent || isTaskComplete}
      />
      <Button
        variant="secondary"
        size="sm"
        className="bad-quest__task--input_button"
        onClick={onSubmit}
        disabled={emailSent || isLoading || isTaskComplete}
      >
        {isTaskComplete ? `Completed` : `Submit`}
        {isTaskComplete && (
          <CheckCircledIcon className="bad-quest__task--check_icon" />
        )}
        {isLoading && <ReloadIcon className="bad-quest__task--reload_icon" />}
      </Button>
    </div>
  );
};

export { Verify };
